import Vue from 'vue'
import { mapGetters } from 'vuex'
import config from '@/config'

export default Vue.extend({
  data() {
    return {
      pushedEntryKey: null,
      pushedEntryKeys: []
    }
  },
  computed: {
    ...mapGetters('Auth', ['token'])
  },
  methods: {
    /**
     * プロフページに遷移
     */
    async $_jumpToProfile(key: string, id: string) {
      if (this.$store.getters.UA_IS_ANDROID && this.$_isScrolling) {
        return
      }
      // // カクツキをなくすために事前にプロフィールデータを取得
      // const data = await this.$_fetchProfile(id)

      // お気に入りにリストからの変更をリアルタイムに反映させるために entry を一時的に確保
      const moduleName = this.$store.getters.fromStoreModuleName
      if (moduleName) {
        this.$store.commit(`${moduleName}/clearTempEntries`)
        this.$store.commit(
          `${moduleName}/setTempEntries`,
          this.$store.getters[`${moduleName}/entries`]
        )
        this.$store.commit(`${moduleName}/setCurrentEntryKey`, key)
      }

      this.$router.push({
        name: 'user',
        params: {
          id: id
          // profile: data.profile,
          // tweets: data.tweets,
          // unread_count: data.unread_count
        }
      })
    },

    /**
     * ホームからプロフページに遷移
     */
    async $_jumpToProfileFromHome(data: any) {
      // entry を一時的に確保
      const moduleName = this.$store.getters.fromStoreModuleName
      if (moduleName) {
        if (moduleName === 'TopUser') {
          this.$store.commit(
            'TopUser/setTempGridEntries',
            this.$store.getters['TopUser/gridEntries']
          )
        }

        this.$store.commit(`${moduleName}/clearTempEntries`)
        this.$store.commit(
          `${moduleName}/setTempEntries`,
          this.$store.getters[`${moduleName}/entries`]
        )
        this.$store.commit(`${moduleName}/setCurrentEntryKey`, data.key)
        if (data.keys) {
          this.$store.commit(`${moduleName}/setCurrentEntryKeys`, data.keys)
        }
      }

      this.$router.push({
        name: 'user',
        params: {
          key: data.key,
          id: data.id,
          unread_count: data.unreadCount,
          profile: data.profile,
          fetchPayload: data.fetchPayload
        }
      })
    },

    /**
     * プロフィールの取得
     */
    async $_fetchProfile(id: string): Promise<any> {
      try {
        const res = await this.$http.post('/user_profile/', {
          page: 'get_user',
          id: id
        })
        if (res.data.error) {
          this.$_alert(res.data.error)
        }
        return res.data
      } catch (err) {
        console.error(err)
      }
    },

    /**
     * ブロック
     */
    async $_doBlock(id: string) {
      const buttonIndex = await this.$_confirm(
        'ブロックを行うとこの人とやり取りできなくなります。よろしいですか？',
        '',
        ['キャンセル', 'ブロックする']
      )
      if (!this.$_clickedConfirmOK(buttonIndex)) {
        return
      }
      try {
        const res = await this.$http.post('/blocklist.php', {
          page: 'block',
          id: id
        })
        if (res.data.error) {
          throw new Error(res.data.error)
        }
        await this.$_alert('ブロックしました')

        // ブロックフラグ
        sessionStorage.setItem('is_blocked', '1')

        // 辿ってきた store module から該当のユーザー(entry)を削除する
        const moduleName = this.$store.getters.fromStoreModuleName
        if (moduleName) {
          if (moduleName === 'TopUser' && this.$store.getters['TopUser/topViewStyle'] === 'grid') {
            this.$store.commit(
              'TopUser/removeGridEntry',
              this.$store.getters['TopUser/currentEntryKeys']
            )
          } else {
            this.$store.commit(
              `${moduleName}/removeEntry`,
              this.$store.getters[`${moduleName}/currentEntryKey`]
            )
          }
          this.$forceUpdate()
        }

        // チャットにプロフアクセスしてブロックすると back したときにブロックしたユーザとのチャットが表示されてしまう対策
        if (this.$store.getters['fromName'] === 'chat') {
          this.$router.go(-2)
        } else {
          this.$router.back()
        }
      } catch (err) {
        console.error(err)
      }
    },

    /**
     * お気に入りをトグル
     */
    async $_toggleFavorite(id: string): Promise<boolean> {
      try {
        const res = await this.$http.post('/user_profile/', {
          page: 'toggle_fav',
          id: id
        })
        if (res.data.error) {
          throw new Error(res.data.error)
        }

        // お気に入りリストからリアルタイムで削除や追加
        const moduleName = this.$store.getters.fromStoreModuleName
        // トップの grid 用
        if (
          moduleName === 'TopUser' &&
          this.$store.getters['TopUser/topViewStyle'] === 'grid' &&
          this.$store.getters['TopUser/activeTab'] === 3
        ) {
          if (res.data.fav) {
            const gridEntries = this.$store.getters['TopUser/tempGridEntries']
            const keys = this.$store.getters['TopUser/currentEntryKeys']
            await this.$store.commit('TopUser/pushGridEntriy', gridEntries[keys[0]][keys[1]])
            const key1 = this.$store.getters['TopUser/gridEntries'].length - 1
            const key2 = this.$store.getters['TopUser/gridEntries'][key1].length - 1
            this.pushedEntryKeys = [key1, key2]
          } else {
            const keys =
              this.pushedEntryKeys.length > 0
                ? this.pushedEntryKeys
                : this.$store.getters['TopUser/currentEntryKeys']
            this.$store.commit('TopUser/removeGridEntry', keys)
          }
        } else {
          if (res.data.fav) {
            const entries = this.$store.getters[`${moduleName}/tempEntries`]
            const key = this.$store.getters[`${moduleName}/currentEntryKey`]
            await this.$store.commit(`${moduleName}/pushEntry`, entries[key])
            this.pushedEntryKey = this.$store.getters[`${moduleName}/entries`].length - 1
          } else {
            const key = this.pushedEntryKey
              ? this.pushedEntryKey
              : this.$store.getters[`${moduleName}/currentEntryKey`]
            this.$store.commit(`${moduleName}/removeEntry`, key)
          }
        }

        return res.data.fav
      } catch (err) {
        console.error(err)
      }
    },

    /**
     * アプリを起動する
     */
    $_tryLaunchApp(query: string) {
      let url = `${config.SERVER_URL}/launch_app.php`
      if (query) {
        url += '?path=' + encodeURIComponent(query)
      }
      location.href = url
    },

    /**
     * 年齢認証
     */
    async $_ageAuth(data: any) {
      const buttonIndex = await this.$_confirm(
        'アプリをご利用いただくために簡単な年齢認証が必要です。',
        '年齢認証',
        ['キャンセル', '認証ページへ']
      )
      if (this.$_clickedConfirmOK(buttonIndex)) {
        this.$_open(data.url + `?app=1&token=${this.token}`)
      }
    },

    /**
     * ポイント購入ダイアログの表示
     */
    async $_showPointBuyDialog(message: string, title: string = '') {
      const buttonIndex = await this.$_confirm(message, title, ['キャンセル', 'ポイント購入'])
      if (this.$_clickedConfirmOK(buttonIndex)) {
        this.$_openPointPage(this.$router)
      }
    }
  }
})
